import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { vulnerabilityOffInterest } from "../../dataStore";
import { fetchJsonData } from "../BesVersionHistory/AssessmentReport";

export const spanStyle: any = {
  fontSize: "1rem",
  fontWeight: 700,
  paddingRight: "13px",
};

function convertString(data: string[]) {
  let result = "";
  data.forEach((value, index) => {
    const space = index < data.length - 1 ? ", " : " ";
    result += value + space;
  });
  return result;
}

function referanceURL(urls: any) {
  const list: any = [];
  urls.forEach((data: any) => {
    const link = (
      <li>
        <a href={ data.url } target="_blank" rel="noopener noreferrer">
          { data.url }
        </a>
      </li>
    );
    list.push(link);
  });
  return list;
}

function range(item: any) {
  const list: any = [];
  item.forEach((value: any) => {
    list.push(
      <div style={ { width: "auto", gridColumnEnd: "span 3" } }>
        <dl
          style={ {
            display: "grid",
            gridTemplateColumns: "max-content minmax(0, auto)",
            gridRowGap: "5px",
            gap: "8px",
          } }
        >
          <dt>Type</dt>
          <dd>ECOSYSTEM</dd>
          <dt>Events</dt>
          <dd>
            <div
              style={ {
                gap: "4px",
                display: "grid",
                margin: 0,
                gridTemplateColumns: "repeat(12, minmax(0, 1fr))",
              } }
            >
              <div style={ { width: "auto", gridColumnEnd: "span 3" } }>
                Introduced
              </div>
              <div
                style={ {
                  fontFamily: "'Overpass Mono', monospace",
                  width: "auto",
                  gridColumnEnd: "span 9",
                  paddingLeft: "53px",
                } }
              >
                { value.events.introduced }
              </div>
              <div style={ { width: "auto", gridColumnEnd: "span 3" } }>
                Fixed
              </div>
              <div
                style={ {
                  fontFamily: "'Overpass Mono', monospace",
                  width: "auto",
                  gridColumnEnd: "span 9",
                  paddingLeft: "53px",
                } }
              >
                { value.events.fixed }
              </div>
            </div>
          </dd>
        </dl>
      </div>
    );
  });
  return list;
}

function displayVersion(versions: any) {
  const list: any = [];
  const versionList = Object.keys(versions);
  versionList.forEach((data: any, index: any) => {
    list.push(
      <>
        <h2
          style={ {
            background: "none",
            fontFamily: '"Overpass Mono", monospace',
            paddingLeft: "0px",
            paddingTop: "14px",
            fontSize: "16px",
          } }
        >
          { " " }
          { data }
        </h2>
        <div
          style={ {
            borderBottom:
              index < versionList.length - 1 ? "1px dashed black" : "",
            display: "flex",
            overflow: "auto",
            flexWrap: "wrap",
            gap: "8px",
            paddingBottom: "12px",
          } }
        >
          { versions[data].map((version: any) => {
            const listVersionDiv: any = [];
            listVersionDiv.push(
              <div style={ { width: "100px", overflowWrap: "break-word" } }>
                { version }
              </div>
            );
            return listVersionDiv;
          }) }
        </div>
      </>
    );
  });
  return list;
}

function displayAffectedVersion(affected: any) {
  if (affected === null) return <></>;
  return (
    <>
      <div
        style={ {
          padding: "14px 14px 14px 25px",
          borderBottom: "1px dashed black",
          display: "grid",
          margin: 0,
          gridGap: "24px",
          gridTemplateColumns: "repeat(12, minmax(0, 1fr))",
        } }
      >
        <h3
          style={ {
            fontFamily: "Overpass, sans-serif",
            fontWeight: "bold",
            width: "auto",
            gridColumnEnd: "span 3",
          } }
        >
          Affected Version
        </h3>
        <div
          style={ {
            fontFamily: "'Overpass Mono', monospace",
            width: "auto",
            gridColumnEnd: "span 9",
          } }
        >
          { displayVersion(affected) }
        </div>
      </div>
    </>
  );
}

function displayAffectedPackage(affected: any) {
  const list: any = [];
  affected.map((value: { package: { ecosystem: string, name: string }, versions: number, ranges: any }) => {
    const data = (
      <>
        <p
          style={ {
            fontSize: "20px",
            fontFamily: "Overpass Mono",
            paddingTop: "12px",
          } }
        >
          { `${value.package.ecosystem} / ${value.package.name}` }
        </p>
        <div
          style={ {
            padding: "14px 14px 14px 25px",
            borderBottom: "1px dashed black",
            display: "grid",
            margin: 0,
            gridGap: "24px",
            gridTemplateColumns: "repeat(12, minmax(0, 1fr))",
          } }
        >
          <h3
            style={ {
              fontFamily: "Overpass, sans-serif",
              fontWeight: "bold",
              width: "auto",
              gridColumnEnd: "span 3",
            } }
          >
            Affected ranges
          </h3>
          { range(value.ranges) }
        </div>
        { displayAffectedVersion(value.versions) }
      </>
    );
    list.push(data);
  });

  return list;
}

function besID(source: any) {
  if (source !== null) {
    return (
      <>
        <dt>Source:</dt>
        <dd>
          <a href={ source } target="_blank" rel="noopener noreferrer">
            { source }
          </a>
        </dd>
      </>
    );
  }
}

function aliases(list: any) {
  if (list.length !== 0) {
    return (
      <>
        <dt>Aliases:</dt>
        <dd>{ convertString(list) }</dd>
      </>
    );
  }
}

function affectedProject(list: any) {
  if (list.length !== 0) {
    return (
      <>
        <dt>Affected Project:</dt>
        <dd>{ convertString(list) }</dd>
      </>
    );
  }
}

function referanceLink(list: any) {
  if (list.length !== 0) {
    return (
      <>
        <dt>Referance:</dt>
        <dd>
          <ul
            style={ {
              padding: 0,
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              overflowWrap: "break-word",
            } }
          >
            { referanceURL(list) }
          </ul>
        </dd>
      </>
    );
  }
}

function ShowVulnerabilityContent() {
  const { cveId }: any = useParams();

  const [report, setreport]: any = useState([]);
  React.useEffect(() => {
    fetchJsonData(vulnerabilityOffInterest, setreport);
  }, []);
  const cve_Id = cveId.slice(1);
  return (
    <>
      {
        report.map((value: any) => {
          if (value.cve_id === cve_Id) {
            return (
              <>
                <dl
                  style={ {
                    display: "grid",
                    gridTemplateColumns: "max-content minmax(0, auto)",
                    gap: "5px 50px"
                  } }
                >
                  { besID(value.source) }
                  { aliases(value.aliases) }
                  <dt>Published:</dt>
                  <dd>{ value.published }</dd>
                  <dt>Modified:</dt>
                  <dd>{ value.modified }</dd>
                  <dt>Details:</dt>
                  <dd>{ value.details }</dd>
                  { affectedProject(value.oss_projects) }
                  { referanceLink(value.references) }
                </dl>
                <div style={ { marginTop: "50px" } }>
                  <h2>Affected packages</h2>

                  <div
                    style={ {
                      borderTop: "1px dashed black",
                      padding: "24px",
                    } }
                  >
                    { displayAffectedPackage(value.affected) }
                  </div>
                </div>
              </>
            );
          }
        })
      }
    </>
  );
}

export default ShowVulnerabilityContent;
